import * as React from 'react';

import Box from '@mui/material/Box';

export default function About(){
    return (
        <Box className='wrapper about'>
            <h2 className='section-title'>About the Journey</h2>
            <p className='desc'>
            The Sea Finance Management Associate (FMA) Program is a 2-year accelerated journey for aspiring talent to build strong accounting and finance foundations, and develop the digital fluency to shape how Finance evolves with technology. Through four 6-month rotations within Sea Finance, you will be immersed in Sea's diverse businesses (Garena, Shopee, and Monee), where you will gain hands-on experience and see firsthand how our Finance teams integrate technology into their work to create value across the ecosystem. Applications are open from 18 August 2026 to 31 October 2026.
            </p>
        </Box>
    );
}
